module.exports = __webpack_public_path__ + "img/parallaxinf.7072390c.png";